import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const modules = [{
  title: 'TOMO 1 — Los fundamentos de la mente del runner',
  items: ['Cómo funciona la mente durante la carrera.', 'Atención plena aplicada al running.', 'El piloto automático.', 'El diálogo interno.', 'Respiración consciente.', 'Cómo desarrollar el hábito.']
}, {
  title: 'TOMO 2 — Respiración para correr mejor',
  items: ['Respiración diafragmática.', 'Respiración nasal.', 'Respiración en fondos largos.', 'Respiración para series.', 'Respiración precompetitiva.', 'Recuperación post entrenamiento.']
}, {
  title: 'TOMO 3 — Concentración y foco',
  items: ['Técnicas de anclaje.', 'Flow.', 'Mantener la atención.', 'Evitar distracciones.', 'Escaneo corporal.', 'Atención kilómetro a kilómetro.']
}, {
  title: 'TOMO 4 — Psicología del corredor',
  items: ['Pensamientos automáticos.', 'Creencias limitantes.', 'Reestructuración cognitiva.', 'Autodiálogo positivo.', 'Confianza.', 'Resiliencia mental.']
}, {
  title: 'TOMO 5 — Competencia y gestión emocional',
  items: ['Ansiedad.', 'Presión.', 'Manejo del miedo.', 'Recuperación después del error.', 'Gestión de la frustración.', 'Mantener la calma.']
}, {
  title: 'TOMO 6 — Protocolos para entrenar y competir',
  items: ['Antes del entrenamiento.', 'Antes de competir.', 'Durante la carrera.', 'Últimos kilómetros.', 'Recuperación.', 'Plan de entrenamiento mental de 90 días.']
}];
export function Curriculum() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section id="contenido" className="py-8 px-4 md:px-8 bg-white" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <div className="text-center mb-5" data-id="element-50">
          <h2 className="font-display font-bold text-3xl md:text-5xl text-ink mb-4" data-id="element-51">
            MINDFULNESS PARA RUNNERS
          </h2>
          <p className="text-lg text-ink/70" data-id="element-52">
            El entrenamiento mental que acompaña cada uno de tus kilómetros.
          </p>
        </div>

        <div className="space-y-4" data-id="element-53">
          {modules.map((mod, idx) => <div key={idx} className="border border-sage/30 rounded-2xl overflow-hidden" data-id="element-54">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 bg-sage-soft hover:bg-sage-light/50 transition-colors text-left" data-id="element-55">
                <span className="font-display font-bold text-lg text-ink" data-id="element-56">
                  {mod.title}
                </span>
                <ChevronDown className={`w-5 h-5 text-forest transition-transform ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>

              {openIdx === idx && <div className="p-6 bg-white" data-id="element-58">
                  <ul className="space-y-3" data-id="element-59">
                    {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/80" data-id="element-60">
                        <span className="text-forest mt-1" data-id="element-61">•</span>
                        <span data-id="element-62">{item}</span>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}